<template>
  <nav aria-label="Progress" class="pt-2">
    <div class=" flex justify-center">
      <ol role="list" class="flex ">
        <li v-for="(step, stepIdx) in progressBar.steps" :key="step.number"
            :class="[stepIdx !== progressBar.steps.length - 1 ? 'pr-20 sm:pr-44' : '', 'relative']">
          <template v-if="step.state === 'complete'">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full bg-green-400"></div>
            </div>
            <div class="relative flex h-8 w-8 items-center justify-center rounded-full bg-green-400">
              <i class="fas fa-check text-white"></i>
            </div>
          </template>
          <template v-else-if="step.state === 'current'">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full bg-gray-200"></div>
            </div>
            <div class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-green-400 bg-white text-green-400"
               aria-current="step">
              <span>{{ step.number }}</span>
            </div>
          </template>
          <template v-else>
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full bg-gray-200"></div>
            </div>
            <div class="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 bg-white border-gray-300 text-gray-300">
              <span>{{ step.number }}</span>
            </div>
          </template>
        </li>
      </ol>
    </div>
    <div class="hidden sm:flex justify-center pt-3">
        <span v-for="(step) in progressBar.steps" :key="step.number"
              class="w-56 first:pl-8 last:pr-8 text-center text-sm font-medium"
              :class="[step.state === 'current' ? ' text-gray-700' : 'text-gray-300']"
        > {{step.name}}</span>
    </div>

  </nav>
</template>


<script setup>
import {useProgressBarStore} from "../stores/progress-bar";

const progressBar = useProgressBarStore();
</script>
